import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes.js';
import scrollBehavior from './scrollBehavior.js';

const router = createRouter({
  history: createWebHistory(),
  routes,
  mode: 'history',
  scrollBehavior,
});

export default router;
